import PyramidChartViz from '../vizs/PyramidChartViz'
import BaseComponent from './BaseComponent'
/**
 * {-EN-}
 * # {componentLabel} (`class {componentClassName}`)
 * The pyramid chart is used to display the distribution of ages across a population divided down the center between male and female members of the population.
 *
 * ### Example Usage
 * ```javascript
 *
 *   import {PyramidChart} from 'sdv-lib'
 *
 *   // Instantiate the chart with a DOM element, a data Array and a config Object
 *   let myChart = new PyramidChart($el, data, config);
 *
 * ```
 *
 * ### Data structure {.section-data-structure}
 * The tabular data for this chart should be a table with 3 columns.
 *
 * Each row represents a distribution. The first column should be the id/label, and the rest of the columns should represent the value releated with its category
 *
 * |    id    |  male  |  female  |
 * | -------- | ------ |  ------  |
 * |   25-39  |    22.4|      15.4|
 * |   16-24  |    52.3|      55.3|
 * |   <16    |    12.8|      34.1|
 *
 * {.data-table}
 *
 * {-ES-}
 * # {componentLabelEs} (`class {componentClassName}`)
 * El gráfico piramidal se utiliza para mostrar la distribución de edades en una población dividida por el centro entre hombres y mujeres de la población.
 *
 * ### Ejemplo de uso
 * ```javascript
 *
 *   import {PyramidChart} from 'sdv-lib'
 *
 *   // Instantiate the chart with a DOM element, a data Array and a config Object
 *   let myChart = new PyramidChart($el, data, config);
 *
 * ```
 *
 * ### Estructura de datos {.section-data-structure}
 * Los datos tabulares de este gráfico deben ser una tabla con 3 columnas.
 *
 * Cada fila representa una distribución. La primera columna debe ser el id/etiqueta, y el resto de las columnas deben representar el valor relacionado con su categoría.
 *
 * |    id    |  male  |  female  |
 * | -------- | ------ |  ------  |
 * |   25-39  |    22.4|      15.4|
 * |   16-24  |    52.3|      55.3|
 * |   <16    |    12.8|      34.1|
 *
 * {.data-table}
 * */
export default class PyramidChartComponent extends BaseComponent {
  static vizClass = PyramidChartViz
  static componentLabel = 'Pyramid chart'
  static componentLabelEs = "Gráfico piramidal"
  static dataFormat = [
    { index: 0, axis: 'x0', types: [String], role: 'id', roleLabel: 'Group' },
    {
      index: 1,
      axis: 'y0',
      label: 'Stack',
      types: [Number, null],
      role: 'value',
      roleLabel: 'Data',
    },
    {
      index: 2,
      axis: 'y1',
      label: 'Stack',
      types: [Number, null],
      role: 'value',
      roleLabel: 'Data',
    },
  ]
  static defaultConfig = {
    title: this.componentLabel,
    ItemsHelper: {
      colorScale: {
        value: 'categorical',
        options: ['categorical'],
        nonEditable: true,
      },
    },
    /**
     * {-EN-} Show the TOTAL value on top of each stack.
     * {-ES-} Muestre el valor TOTAL en la parte superior de cada pila.
     */
    showDatumValues: {
      type: Boolean,
      default: false,
      exposed: true,
    },
    AxisHelper: {
      y: {
        trimThreshold: {
          nonEditable: true,
        },
      },
      x: {
        showTickValues: {
          nonEditable: true,
        },
      },
    },
    TooltipBehavior: {
      axis: {
        y: {
          tooltipValueFormat: {
            exposed: true,
            nonEditable: false,
          },
        },
      },
      getHtml: function (d) {
        return `
        <div class="tip-value important">${this.formatTooltipValue(d.value, 'y')}</div>
        <div class="tip-id">
          <span class="icon" style="display: inline-block; width: 9px; height: 9px; border-radius: 50%; background: ${this.color(
            { id: d.parentId }
          )}; margin-right: 3px"></span>
          ${d.parentId}
        </div>
        <div class="secondary">${this.formatValue(d.id, 'x')}</div>
        `
      },
    },
  }
}
